import { render, staticRenderFns } from "./AdminNotice.vue?vue&type=template&id=5817c256&scoped=true&"
import script from "./AdminNotice.vue?vue&type=script&lang=js&"
export * from "./AdminNotice.vue?vue&type=script&lang=js&"
import style0 from "./AdminNotice.vue?vue&type=style&index=0&id=5817c256&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5817c256",
  null
  
)

export default component.exports